import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Header } from "@/components/Header";
import { HeroSection } from "@/components/HeroSection";
import heroImage from "@/assets/masonry-pro-hero-2.webp";
import { ReviewsSection } from "@/components/ReviewsSection";
import { IntroSection } from "@/components/IntroSection";
import { WhyUsSection } from "@/components/WhyUsSection";
import { TrustVerificationStrip } from "@/components/TrustVerificationStrip";
import { ServicesSection } from "@/components/ServicesSection";
import { GallerySection } from "@/components/GallerySection";
import { ServiceAreaSection } from "@/components/ServiceAreaSection";
import { MapSection } from "@/components/MapSection";
import { CTASection } from "@/components/CTASection";
import { PhoneShortsSection } from "@/components/PhoneShortsSection";
import { Footer } from "@/components/Footer";
import { AccessibilityWidget } from "@/components/AccessibilityWidget";
import { BackToTop } from "@/components/BackToTop";
import { ScrollCTAPopup } from "@/components/ScrollCTAPopup";
import { HomepageFAQSection } from "@/components/HomepageFAQSection";
import { LazySection } from "@/components/LazySection";
import { REVIEW_COUNT } from "@/config/reviews";


const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Local Masonry Contractor Totowa, NJ | Masonry Pro Construction</title>
        <meta name="description" content={`Searching masonry contractors near me? Based in Totowa, we've served North Jersey for 35+ years. Bergen, Essex, Passaic, Morris. ${REVIEW_COUNT}+ five-star reviews.`} />
        <meta property="og:title" content="Local Masonry Contractor Totowa, NJ | Masonry Pro Construction" />
        <meta property="og:description" content={`Searching masonry contractors near me? Based in Totowa, we've served North Jersey for 35+ years. Bergen, Essex, Passaic, Morris. ${REVIEW_COUNT}+ five-star reviews.`} />
        <meta name="twitter:title" content="Local Masonry Contractor Totowa, NJ | Masonry Pro Construction" />
        <meta name="twitter:description" content={`Searching masonry contractors near me? Based in Totowa, serving North Jersey for 35+ years. Bergen, Essex, Passaic, Morris. ${REVIEW_COUNT}+ five-star reviews.`} />
        <link rel="preload" as="image" href={heroImage} />
        <meta property="og:image" content="https://masonry-pro.com/og/services.jpg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image:type" content="image/jpeg" />
      </Helmet>
      
      <Header />
      <main>
        <HeroSection />
        <IntroSection />
        <WhyUsSection />
        <TrustVerificationStrip />
        <ReviewsSection />

        <LazySection minHeight="800px">
          <PhoneShortsSection
            title="See Our"
            highlightedTitle="Work in Action"
            subtitle={<>Real project walkthroughs from across North Jersey. Or browse all our <Link to="/videos" className="text-secondary hover:underline">project videos</Link>.</>}
            videos={[
              {
                id: "BiS2ELaDD0E",
                name: "Masonry Pro Construction – Project Walkthrough",
                description: "Masonry project walkthrough by Masonry Pro Construction in North Jersey.",
                title: "Project Walkthrough",
                location: "North Jersey",
              },
              {
                id: "Fogsfyz7P18",
                name: "Paver & Hardscape Project",
                description: "Paver and hardscape project by Masonry Pro Construction in North Jersey.",
                title: "Paver & Hardscape Project",
                location: "North Jersey",
              },
              {
                id: "IaLfa_u0pFQ",
                name: "Masonry Project Highlight",
                description: "Masonry project highlight by Masonry Pro Construction in North Jersey.",
                title: "Masonry Project Highlight",
                location: "North Jersey",
              },
              {
                id: "bcQ5eroM02M",
                name: "Masonry Pro Construction – Project Highlight",
                description: "Masonry project highlight by Masonry Pro Construction in North Jersey.",
                title: "Project Highlight",
                location: "North Jersey",
              },
            ]}
          />
        </LazySection>

        <ServicesSection />

        <LazySection minHeight="600px">
          <GallerySection />
        </LazySection>

        <ServiceAreaSection />

        <LazySection minHeight="450px">
          <MapSection />
        </LazySection>

        <LazySection minHeight="400px">
          <HomepageFAQSection />
        </LazySection>

        <CTASection />
      </main>
      <Footer />
      <AccessibilityWidget />
      <BackToTop />
      <ScrollCTAPopup />
    </div>
  );
};

export default Index;
